import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useNavigate } from 'react-router-dom'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'

function SurveyComponent({
  convertedSurvey,
  ac,
  tk,
  pid,
  imagesReadingTime,
  setIsLoading,
  setImagesReadingTime,
}) {
  // 問卷編號
  // const pid = pid
  // 專案編號
  const pi = pid

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey.pages)
  // }, [])

  const survey = new Model(convertedSurvey)
  const navigate = useNavigate()
  const host = 'https://nezcdev.dataa.com.tw'
  // 使⽤者上傳填答結果
  const SubmitAnswersUrl = '/clientWeb/v1/SubmitAnswers'
  // 檢查是否存在帶有 'imgWrap50' className 的元素
  function hideSdBtnIfImgWrapExists() {
    if (document.querySelector('.imgWrap50')) {
      // 如果存在，找到所有帶有 'sd-btn' className 的元素
      const sdBtnElements = document.querySelectorAll('.sd-btn')
      const thirtySecondDelete = document.querySelectorAll(
        '.thirtySecondDelete'
      )

      // 遍歷每一個 'sd-btn' 元素並設置其 display 為 'none'
      sdBtnElements.forEach((element) => {
        element.style.display = 'none'
      })

      // 30秒後恢復 'sd-btn' 元素的顯示
      setTimeout(() => {
        sdBtnElements.forEach((element) => {
          element.style.display = ''
        })
        thirtySecondDelete.forEach((element) => {
          element.style.display = 'none'
        })
        // TODO:
      }, imagesReadingTime * 1000) // 30秒
    }
  }
  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555
    // 多選之後排序小幫手
    const question = survey.getQuestionByName(options.name)
    // console.log('question', question.title)

    // if (question) {
    //   if (options.name === 'q0') {
    //     // 記得設定 visibleIf 有上題才看得到下題
    //     // 拿到選項文字
    //     const selectedText = question.choices.filter(
    //       (choice) => choice.value === options.value
    //     )[0].text

    //     const rankingQuestion = survey.getQuestionByName('q1')

    //     // 将选择的选项更新到排序问题中
    //     rankingQuestion.title = `如果${selectedText}可能沒有機會當選總統，你會轉投給哪組候選人？`
    //     const originalChoices = rankingQuestion.choices.map((v) => {
    //       return { ...v }
    //     })
    //     rankingQuestion.choices = originalChoices.filter(
    //       (v) => v.text !== selectedText
    //     )
    //     console.log(
    //       'originalChoices',
    //       originalChoices.filter((v) => v.text !== selectedText)
    //     )
    //     console.log('rankingQuestion.choices', rankingQuestion.choices)
    //   }
    //   // 单选问题
    //   if (question.getType() === 'radiogroup') {
    //     const selectedText = question.choices.filter(
    //       (choice) => choice.value === options.value
    //     )[0].text
    //     // console.log('Selected text:', selectedText)
    //   }
    //   // 多选问题
    //   else if (question.getType() === 'checkbox') {
    //     const selectedTexts = options.value.map((value) => {
    //       return question.choices.filter((choice) => choice.value === value)[0]
    //         .text
    //     })
    //     // console.log('Selected texts:', selectedTexts)
    //   }
    // }
    // if (options.name === 'q0') {
    //   // 記得設定 visibleIf 有上題才看得到下題
    //   // 拿到選項文字
    //   const selectedOptions =
    //     options.value?.map((value) => {
    //       return question.choices.filter((choice) => choice.value === value)[0]
    //         .text
    //     }) || []

    //   const rankingQuestion = survey.getQuestionByName('q1')

    //   // 将选择的选项更新到排序问题中
    //   rankingQuestion.choices = selectedOptions
    // }
  }

  /**
   * survey.onValueChanged.add(function (survey, options) {
    // 获取问题对象
    var question = survey.getQuestionByName(options.name);

    if (question) {
        // 单选问题
        if (question.getType() === "radiogroup") {
            var selectedText = question.choices.filter(choice => choice.value === options.value)[0].text;
            console.log("Selected text:", selectedText);
        }
        // 多选问题
        else if (question.getType() === "checkbox") {
            var selectedTexts = options.value.map(value => {
                return question.choices.filter(choice => choice.value === value)[0].text;
            });
            console.log("Selected texts:", selectedTexts);
        }
    }
});

   */

  const canShowPrevButtonPages = null

  const titleDivider = '||'
  function updateStringComponents(_, options) {
    options.htmlElement.querySelectorAll('.sv-string-viewer').forEach((el) => {
      const text = el.innerText
      if (text.indexOf(titleDivider) > -1) {
        const strings = text.split(titleDivider)
        // el.title = strings[1]
        el.innerText = strings[0]
        // el.classList.add('mystyle')
        el.innerHTML =
          el.innerHTML +
          `<button class="tooltip mybutton">?<span class="tooltiptext">${strings[1]}</span></button>`
        // button 會讓字掉下來
        // `<button class="tooltip mybutton"><img style='margin:4px 0' src="images/circle-question-solid.svg" alt="circle-question"><span class="tooltiptext">${strings[1]}</span></button>`
      }
    })
  }

  useSubmitAnswers({
    survey,
    pid,
    pi,
    ac,
    tk,
    hideSdBtnIfImgWrapExists,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    setImagesReadingTime,
    updateStringComponents,
  })

  return <Survey model={survey} />
}

export default SurveyComponent
